export default class EmploymentDetail {
    constructor() {
        this.placeOfEmployment = null;
        this.year = null;   // NOT USED ANYMORE
        this.years = null;
        this.typeOfWork = null;
        this.locationOfEmployment = null;
    }
}